import CompleteAccount from './CompleteAccount'
export default CompleteAccount
